import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../images/Collagelogo.png';
import '../../admin/style/login.css';
import '../styles/login.css'
import Header from '../../repeat/Header';
import axios from 'axios';


const ForgotPasswordPopup = ({ onClose }) => {
  return (
    <div className="popup">
      <div className="popup-content0">
        <span className="close-btn" onClick={onClose}>&times;</span>
        <h2>Forgot Password</h2>
        <p>If you've forgotten your password, please contact the admin </p>
      </div>
    </div>
  );
};

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPopup, setShowPopup] = useState(false); // State to control pop-up visibility
  const [isLoading, setIsLoading] = useState(true);
  
  const navigate = useNavigate();
  useEffect(() => {
      const storedUsername = sessionStorage.getItem('table_name');
      if (storedUsername) {
        // If a session exists, redirect to the dashboard
        navigate('/Upload');
      } else {
        setIsLoading(false); // Mark loading as complete only if no session
      }
    }, [navigate]);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const url = 'https://gptkpm.in/backend/events/code/login.php';

    let fData = new FormData();
    fData.append('username', username);
    fData.append('password', password);

    try {
      const response = await axios.post(url, fData);

      if (response.data.status === "success") {
        sessionStorage.setItem('username', username);
        sessionStorage.setItem('table_name', response.data.table_name);
        sessionStorage.setItem('department', response.data.department);

        console.log("Login successful");
        navigate("/Upload");
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  return (
    <div className="container1">
      <div><Header /></div>
      <div className="logincontainer">
        <div className="box1">
          <img src={Logo} alt="Login" />
        </div>
        <div className="box2">
          <form onSubmit={handleSubmit}>
            <div className="text">
              <h1>Welcome</h1>
              <p>Please Login To Events Dashboard</p>
            </div>
            <div className="input">
              <input
                type="text"
                id="username"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <input
                type="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div className="password">
                <div className="showpassword">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      const input = document.getElementById("password");
                      input.type = e.target.checked ? "text" : "password";
                    }}
                  />
                  <p style={{whiteSpace:"nowrap"}}>Show Password</p>
                </div>
                <a href="#" onClick={() => setShowPopup(true)}>Forgot Password?</a>
              </div>
              <input type="submit" />
            </div>
          </form>
        </div>
      </div>

      {/* Conditionally render the Forgot Password popup */}
      {showPopup && <ForgotPasswordPopup onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default Login;
